import { PUBLIC_API_BASE } from '../config/publicApi';

export const DEFAULT_PROGRAMMES = [
  { id: 'child-sponsorship', name: 'Sponsorships Funded', type: 'fixed', oneTimeAmount: 11880, monthlyAmount: 990, unitSingular: 'Sponsorship', unitPlural: 'Sponsorships', unitOptions: [1, 2, 3, 5], impactLabel: 'Sponsorships funded', description: 'Support education, healthcare and essential care.' },
  { id: 'donate-food', name: 'Donate Food', type: 'fixed', oneTimeAmount: 15000, monthlyAmount: 15000, unitSingular: 'Day', unitPlural: 'Days', unitOptions: [1, 2, 3, 7], impactLabel: 'Food-service days funded', description: 'Help provide meals for approximately 500 people per funded day.' },
  { id: 'general-donations', name: 'Other Amount', type: 'open', unitOptions: [], impactLabel: '', description: 'Contribute any amount where support is needed most.' },
];

export const availableProgrammes = (items) => items.filter((item) => item.active !== false && (item.status || 'inprogress') === 'inprogress').sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));

export const loadProgrammes = async () => {
  if (['localhost', '127.0.0.1'].includes(window.location.hostname)) {
    const saved = JSON.parse(localStorage.getItem('alcLocalProgrammes') || 'null');
    if (Array.isArray(saved)) return saved;
  }
  const response = await fetch(`${PUBLIC_API_BASE}/programmes`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' });
  if (!response.ok) throw new Error('Programmes could not be loaded. Please try again.');
  const result = await response.json();
  return result.programmes || [];
};
